/* crocs-carousel @ 1.0.0 — arrastre y flechas de la pista horizontal.

   El diseno de Crocs no dibuja flechas en las calugas ni en las categorias de
   Jibbitz, pero si en "Recomendados para ti" y en "Encuentra tu Vibe". Aca
   viven las dos cosas: el arrastre con el puntero (que en desktop es la unica
   forma de mover una pista de scroll con mouse) y las flechas cuando la seccion
   las incluye.

   Enganche: [data-crocs-carousel] en la pista y, opcionalmente,
   [data-crocs-carousel-prev] / [data-crocs-carousel-next] en el mismo
   contenedor posicionado. */
(function () {
  'use strict';

  /* Menos que esto es un clic, no un arrastre: si no, al soltar sobre un item
     con enlace se abriria la pagina. */
  var DRAG_THRESHOLD = 6;

  function setupDrag(track) {
    var pointerId = null;
    var startX = 0;
    var startScroll = 0;
    var dragging = false;

    track.addEventListener('pointerdown', function (event) {
      if (event.button !== 0 && event.pointerType === 'mouse') return;
      if (track.scrollWidth <= track.clientWidth) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      dragging = false;
    });

    track.addEventListener('pointermove', function (event) {
      if (pointerId === null || event.pointerId !== pointerId) return;

      var delta = event.clientX - startX;

      if (!dragging) {
        if (Math.abs(delta) < DRAG_THRESHOLD) return;
        dragging = true;
        track.classList.add('is-dragging');
        /* Con la captura el arrastre sigue vivo aunque el puntero se salga. */
        if (track.setPointerCapture) track.setPointerCapture(pointerId);
      }

      track.scrollLeft = startScroll - delta;
      event.preventDefault();
    });

    function release(event) {
      if (pointerId === null || (event && event.pointerId !== pointerId)) return;

      if (track.releasePointerCapture && track.hasPointerCapture && track.hasPointerCapture(pointerId)) {
        track.releasePointerCapture(pointerId);
      }

      pointerId = null;
      if (!dragging) return;

      /* La clase sale en el siguiente cuadro: mientras siga puesta, el click
         que dispara el navegador al soltar no llega al item. */
      requestAnimationFrame(function () {
        track.classList.remove('is-dragging');
      });
      dragging = false;
    }

    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);

    /* Arrastrar imagenes o enlaces cancelaria el gesto a medio camino. */
    track.addEventListener('dragstart', function (event) {
      if (dragging) event.preventDefault();
    });
  }

  function setupArrows(track) {
    var scope = track.closest('[data-crocs-carousel-scope]') || track.parentNode;
    if (!scope) return;

    var prev = scope.querySelector('[data-crocs-carousel-prev]');
    var next = scope.querySelector('[data-crocs-carousel-next]');
    if (!prev && !next) return;

    /* Un paso es lo que mide un item mas su separacion: asi la pista queda
       siempre alineada al inicio de un item. */
    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', sync);
    window.addEventListener('resize', sync);
    sync();
  }

  /* Puntos de paginacion: el diseno (Figma 220:6021) muestra uno por pagina,
     con el activo en pastilla. Las paginas se calculan del ancho visible, asi
     que la cuenta se ajusta sola al cambiar de breakpoint. */
  function setupDots(track) {
    var scope = track.closest('[data-crocs-carousel-scope]') || track.parentNode;
    if (!scope) return;

    var wrap = scope.querySelector('[data-crocs-carousel-dots]');
    if (!wrap) return;

    var pages = 0;

    function pageCount() {
      if (!track.clientWidth) return 1;
      return Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
    }

    function current() {
      if (!track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function build() {
      var n = pageCount();
      if (n === pages) return;
      pages = n;
      wrap.textContent = '';

      var i;
      for (i = 0; i < n; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'crocs-carousel-dot';
        dot.setAttribute('data-crocs-carousel-dot', i);
        dot.setAttribute('aria-label', String(i + 1));
        wrap.appendChild(dot);
      }

      wrap.hidden = n < 2;
      sync();
    }

    function sync() {
      var active = current();
      var dots = wrap.children;
      var i;
      for (i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', i === active ? 'true' : 'false');
      }
    }

    wrap.addEventListener('click', function (event) {
      var dot = event.target.closest('[data-crocs-carousel-dot]');
      if (!dot) return;
      var i = Number(dot.getAttribute('data-crocs-carousel-dot'));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    });

    track.addEventListener('scroll', sync);
    window.addEventListener('resize', build);
    build();
  }

  function init() {
    var tracks = document.querySelectorAll('[data-crocs-carousel]');
    var n;

    for (n = 0; n < tracks.length; n++) {
      if (tracks[n].dataset.crocsReady) continue;
      tracks[n].dataset.crocsReady = 'true';
      setupDrag(tracks[n]);
      setupArrows(tracks[n]);
      setupDots(tracks[n]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
